import { jsx as _jsx } from "react/jsx-runtime";
import AccordionBlockComponent, {} from '../../../accordionblock';
const AccordionBlock = ({ value }) => (_jsx(AccordionBlockComponent, { title: value.title, titleHtmlMarkup: value.titleHtmlMarkup, icon: value.icon, size: value.size, color: value.color, items: value.items }));
export default AccordionBlock;
